import axios from 'axios';
import { setupInterceptors } from './Interceptor';

const axiosInstance = axios.create();

setupInterceptors(axiosInstance);

export default axiosInstance;
